import { PREDICT_RESULT } from '../../shared/types';
import type { PredictResult } from '../../shared/types';

export function getPredictResult(
  settled: boolean,
  settleStatus: 'PENDING' | 'WON' | 'LOST' | 'PUSH' | null | undefined,
): PredictResult | null {
  if (!settled) return null;
  if (settleStatus == null) return PREDICT_RESULT.NOT_JOINED;
  if (settleStatus === 'WON') return PREDICT_RESULT.WIN;
  if (settleStatus === 'LOST') return PREDICT_RESULT.LOSE;
  if (settleStatus === 'PUSH') return PREDICT_RESULT.PUSH;
  return null;
}
